export const passwordValidate = [
  { required: true, message: "Please input password!" },
  { min: 8, message: "Password must be minimum 8 characters." },
];

export const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};
